import React from "react";
import ScrollArea from "react-scrollbar";
import classNames from "classnames";
import { connect } from "react-redux";
import * as redux from "redux";
// Routing
import * as appRouting from "appRouting";
import * as userActions from "user/user/actions";
// Components
import { ErrorMessageBlock } from "common/ui/components/error/ErrorMessageBlock";
import { MaintenanceMessageBlock } from "common/ui/components/error/MaintenanceMessageBlock";
import { Loading } from "common/ui/loading/Loading";
import SideBar from "app/application/ui/sideBars/SideBar";
import Collapsable from "app/application/ui/sideBars/Collapsable";
import HoverInfoWrapper from "common/ui/components/tooltips/HoverInfoWrapper";
// Helpers
import { resizeHelper } from "common/resizeHelper";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./AppMode.less";
const mapStateToProps = (state) => ({
    application: state.app.app,
    user: state.user
});
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
    userActions: redux.bindActionCreators(userActions, dispatch)
});
var AppPageStateToRender;
(function (AppPageStateToRender) {
    AppPageStateToRender[AppPageStateToRender["FetchingUserData"] = 0] = "FetchingUserData";
    AppPageStateToRender[AppPageStateToRender["NotAuthenticated"] = 1] = "NotAuthenticated";
    AppPageStateToRender[AppPageStateToRender["NotAuthorised"] = 2] = "NotAuthorised";
    AppPageStateToRender[AppPageStateToRender["Error"] = 3] = "Error";
    AppPageStateToRender[AppPageStateToRender["UnderMaintenance"] = 4] = "UnderMaintenance";
    AppPageStateToRender[AppPageStateToRender["Contents"] = 5] = "Contents";
})(AppPageStateToRender || (AppPageStateToRender = {}));
//-- Component -------------------------------------------------------------------------------------------------------------------------------
class AppMode extends React.Component {
    constructor(props, context) {
        super(props, context);
        this._officeId = null;
        this._agencyId = null;
        //-- Click handlers -----------------
        this.onLoginClick = () => { appRouting.loginNavigate(this.props.dispatch); };
        this.onRetryClick = () => { location.href = location.href; };
        this.onHomeClick = () => { appRouting.homeNavigate(this.props.dispatch); };
        this.renderExpander = (isOpen) => {
            if (isOpen) {
                return React.createElement("span", { className: styles.iconHolder },
                    React.createElement("span", { className: "fa fa-angle-left", "aria-hidden": "true" }));
            }
            else {
                return React.createElement("span", { className: styles.iconHolder },
                    React.createElement("span", { className: "fa fa-angle-right", "aria-hidden": "true" }));
            }
        };
        // Expander click
        this.onExpanderClick = () => {
            if (this.props.user.userAccess.length == 1) {
                return;
            }
            if (this._officeId || this._agencyId) {
                this.setState({ userWantsOpen: !this.state.userWantsOpen });
                resizeHelper.forceResize();
            }
        };
        this.state = { userWantsOpen: true };
    }
    //-- Render Helpers -----------------
    renderFetchingUserData() {
        return React.createElement(Loading, null);
    }
    renderNotAuthenticated() {
        return React.createElement(ErrorMessageBlock, { title: "You need to log in to view this page.", subTitle: "Follow the link to log in.", buttonText: "Log In", buttonCallback: () => this.onLoginClick() });
    }
    renderNotAuthorised() {
        return React.createElement(ErrorMessageBlock, { title: "You are not authorised to view this page.", subTitle: "Try logging in with the correct user credentials", buttonText: "Login", buttonCallback: () => this.onLoginClick() });
    }
    renderError() {
        return React.createElement(ErrorMessageBlock, { title: "Hmmm... something went wrong", subTitle: "Please try refreshing the page or try again", buttonText: "Try Again", buttonCallback: () => this.onRetryClick(), button2Text: "Home", button2Callback: () => this.onHomeClick() });
    }
    renderUnderMaintenance() {
        return React.createElement(MaintenanceMessageBlock, { title: "Insights will be back soon", subTitle: this.props.application.underMaintenanceMessage, buttonText: "Try Again", buttonCallback: () => this.onRetryClick() });
    }
    renderContents() {
        let urlOfficeId = this.props.params.officeId;
        let urlAgencyId = this.props.params.agencyId;
        if (urlOfficeId) {
            this._officeId = urlOfficeId;
            this._agencyId = null;
        }
        else if (urlAgencyId) {
            this._officeId = null;
            this._agencyId = urlAgencyId;
        }
        else if (this.props.location.pathname == "/") {
            this._officeId = null;
            this._agencyId = null;
        }
        // Determine if menu is open
        let isOpen = false;
        let isForcedOpen = false;
        if (!this._officeId && !this._agencyId) {
            isOpen = true;
            isForcedOpen = true;
        }
        else {
            isOpen = this.state.userWantsOpen;
        }
        return (React.createElement("div", { className: styles.pageBlock },
            React.createElement(Collapsable, { isOpen: isOpen },
                React.createElement(ScrollArea, { speed: 0.8, className: styles.scrollArea, horizontal: false, vertical: true, smoothScrolling: true },
                    React.createElement(SideBar, { user: this.props.user, location: this.props.location, officeId: this._officeId, agencyId: this._agencyId, hasSelection: !!this._officeId || !!this._agencyId, isExpanded: isOpen, onExpandClick: () => this.onExpanderClick() })),
                React.createElement("div", { className: classNames(styles.expander, isForcedOpen && styles.hiddenExpander), onClick: () => this.onExpanderClick() },
                    React.createElement(HoverInfoWrapper, { tipText: "Expand or Contract the side panel" }, this.renderExpander(isOpen)))),
            this.props.children));
    }
    getPageStateToRender() {
        const { application } = this.props;
        if (application.isFetchingUserData) {
            return AppPageStateToRender.FetchingUserData;
        }
        else if (!application.isAuthenticatedToView) {
            return AppPageStateToRender.NotAuthenticated;
        }
        else if (!application.isAuthorisedToView) {
            return AppPageStateToRender.NotAuthorised;
        }
        else if (application.isErrorView) {
            return AppPageStateToRender.Error;
        }
        else if (application.isUnderMaintenanceView) {
            return AppPageStateToRender.UnderMaintenance;
        }
        else {
            return AppPageStateToRender.Contents;
        }
    }
    //-- Render --------------------------
    render() {
        switch (this.getPageStateToRender()) {
            case AppPageStateToRender.FetchingUserData: return this.renderFetchingUserData();
            case AppPageStateToRender.NotAuthenticated: return this.renderNotAuthenticated();
            case AppPageStateToRender.NotAuthorised: return this.renderNotAuthorised();
            case AppPageStateToRender.Error: return this.renderError();
            case AppPageStateToRender.UnderMaintenance: return this.renderUnderMaintenance();
            case AppPageStateToRender.Contents: return this.renderContents();
            default: return this.renderError();
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AppMode);
